import { render, staticRenderFns } from "./OrgTreeTable.vue?vue&type=template&id=87abc35c&scoped=true"
import script from "./OrgTreeTable.vue?vue&type=script&lang=js"
export * from "./OrgTreeTable.vue?vue&type=script&lang=js"
import style0 from "./OrgTreeTable.vue?vue&type=style&index=0&id=87abc35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87abc35c",
  null
  
)

export default component.exports